import React from 'react';
import {Routes, Route} from 'react-router';
import {
  Default,
  AppStore,
  PaymentPlanCreateRedirect,
  EDDASubmitted
} from '.';

interface IRoutersProps {}

const Routers: React.FC<IRoutersProps> = () => {
  return (
    <Routes>
      <Route path="/:country_code/s/:store_id/" element={<PaymentPlanCreateRedirect />} />
      <Route
        path="/:country_code/b/oc/:order_campaign_referred_code/"
        element={<PaymentPlanCreateRedirect />}
      />
      <Route path="/:country_code/order" element={<PaymentPlanCreateRedirect />} />
      <Route path="/edda/submitted" element={<EDDASubmitted />} />
      <Route path="/appstore" element={<AppStore />} />
      <Route path="/*" element={<Default />} />
    </Routes>
  );
};

export default Routers;
